export const getSession = (key)=>{
    let msg = sessionStorage.getItem(key);
    msg = msg ? JSON.parse(msg) : ''
    return msg
}

export const setSession = (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
}